import http from '../utils/http.js'
const project = 'sci/'

const dict = {
  getVersion(data) {
    const url = project + 'setting/option/global/version'
    return http.get(url, data).then(res => {
      return res
    })
  },

  getAll(data) {
    const url = project + 'setting/option/global'
    return http.get(url, data).then(res => {
      return res
    })
  },

  single(type) {
    const url = project + 'setting/option'
    return http.get(url, { type, enabled: true }).then(res => {
      return res
    })
  }
}
export default dict
